import axios from 'axios';
import URL_CONST from '../../../config/url';
import {getHeaders} from '../../../store/dataService';

type DataSetContext = {
  id: string;
};

export class DataSet {
  private id: string;

  static ADD_RAW_DATA_TASK_ID = 'ADD_RAW_DATA';

  constructor({id}: DataSetContext) {
    this.id = id;
  }

  getId() {
    return this.id;
  }

  async finalizeAddRawData(projectId: string) {
    if (!projectId) {
      throw new Error('Project ID is required');
    }

    try {
      const headers = await getHeaders();
      const response = await axios.post(
        URL_CONST.DSS_FINALIZE_ADD_RAW_DATA,
        {
          projectId,
        },
        {
          headers,
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async addRawData(projectId: string, preparationContainerId?: string) {
    if (!projectId) {
      throw new Error('Project ID is required');
    }

    try {
      const headers = await getHeaders();
      const response = await axios.post(
        URL_CONST.DSS_ADD_RAW_DATA,
        {},
        {
          headers,
          params: {datasetId: this.id, projectId, preparationContainerId},
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
